// @flow weak
import { Map, fromJS } from "immutable";

import {
    CATALOGS_FILTERS,
    CATALOGS_RESET,
    FEATURED_CATALOGS_FETCH,
    FEATURED_CATALOGS_FETCH_CANCEL,
    CATALOGS,
} from "constants/action-types";

export const fetchCatalogs = (query = {}) => {
    return {
        payload: query,
        meta: {},
        type: CATALOGS.FETCH.START,
    };
};

export const fetchCatalogsNextPage = (nextPage) => {
    return {
        meta: {
            nextPage,
        },
        type: CATALOGS.FETCH.START,
    };
};

export const catalogsFilters = (filters) => {
    return {
        type: CATALOGS_FILTERS,
        payload: Map.isMap(filters) ? filters : fromJS(filters),
    };
};

export const reset = () => ({ type: CATALOGS_RESET });

export const fetchFeaturedCatalogs = (payload) => ({
    payload,
    type: FEATURED_CATALOGS_FETCH,
});

export const cancelFetchFeaturedCatalogs = () => ({ type: FEATURED_CATALOGS_FETCH_CANCEL });
